import { Box, Stack, Typography } from '@mui/material'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

interface Props {
  value: string | number | undefined
}

const HumanNumber = ({ value }: Props): JSX.Element => {
  return (
    <Typography variant="body1" color="textSecondary">
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={0.5}
      >
        <PersonOutlineIcon />
        <Box component="span" data-testid={`human-number-${value}`}>
          {value}
        </Box>
      </Stack>
    </Typography>
  )
}

export default HumanNumber
